<template>
  <v-dialog
      v-model="showModalInfo"
      @close="hideModal"
      :max-width="getMaxWidth"
      :scrollable="scrollable"
      :persistent="persistent"
      :retain-focus="false"
  >
  <v-card>
    <div class="d-flex flex-row justify-end">
      <v-btn
          v-if="layout === 'vobDocument' || layout === 'modalForm' || layout === 'modalSelectTable' || layout === 'modalProjectForm' || layout === 'modalEstimate' || layout === 'modalClientForm' || layout === 'modalProjectReportEntriesForm' || layout === 'guidesModal'
          || layout === 'modalCreateInvoice'"
          icon
          dark
          @click="hideModal"
          color="black"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-card-title class="headline modal-title">{{ headModal }}
      <slot name="header"></slot>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <p class="content modal-body-text" v-html="textModal">
            </p>
            <slot name="body"></slot>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <slot name="actions"></slot>
      <template v-if="visDisAgreeBtn">
        <v-btn
            color="primary"
            outlined
            class="mr-3"
            @click="doOperationSecond"
        >
          {{ btnDisAgreeText }}
        </v-btn>
      </template>
      <template v-if="!hiddenAgreeBtn">
        <v-btn
            id=""
            color="primary"
            :loading="isLoadingBtn"
            @click="doOperation"
        >
          {{ btnAgreeText }}
        </v-btn>
      </template>

    </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<style src="./ModalInfo.scss" lang="scss"></style>

<script>
export default {
  name: "ModalInfo",
  props: {
    showModal: Boolean,
    headModal: String,
    textModal: [Number, String],
    visDisAgreeBtn: Boolean,
    btnAgreeText: String,
    typeInfo: String,
    idModalBtn: String,
    idData: [Number, Object],
    isLoadingBtn: Boolean,
    btnDisAgreeText: String,
    hiddenAgreeBtn: Boolean,
    layout: String,
    scrollable: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showModalInfo: {
      get: function () {
        return this.showModal;
      },
      set: function (value) {
        if(value === false) {
          this.$emit('clicked');
        }
        return value;
      }
    },
    getMaxWidth: function() {
      if(this.layout === "modalSelectTable" || this.layout === "modalClientForm" || this.layout === "guidesModal" || this.layout === "vobDocument") {
        return 990;
      } else if(this.layout === "modalEstimate" || this.layout === "modalCreateTimeReport" || this.layout === "modalProjectForm" || this.layout === "modalClientForm" || this.layout === "modalProductForm" || this.layout === 'modalCalculationForm') {
        return 1300;
      } else if(this.layout === "modalProjectReportEntriesForm") {
        return 1700;
      } else if(this.layout === "modalCreateInvoice") {
        return 1400;
      } else {
        return 590;
      }
    }
  },
  methods: {
    hideModal: function() {
      if(this.showModalInfo) {
        this.$emit('clicked');
      }
    },
    doOperation: function() {
      this.$emit('clicked');
      this.$emit("doOperation", this.idData);
    },
    doOperationSecond: function() {
      this.$emit('clicked');
      this.$emit('doOperationSecond');
    }
  },
}
</script>